import { FC } from 'react'

import { ActiveCountryId } from '../../utils/constants'
import GermanFlagSmall from './Flags/GermanFlagSmall'
import FinnishFlagSmall from './Flags/FinnishFlagSmall'
import AustrianFlagSmall from './Flags/AustrianFlagSmall'
import BelgianFlagSmall from './Flags/BelgianFlagSmall'
import DutchFlagSmall from './Flags/DutchFlagSmall'
import ItalianFlagSmall from './Flags/ItalianFlagSmall'
import SwedishFlagSmall from './Flags/SwedishFlagSmall'

interface CountryFlagProps {
  countryId: ActiveCountryId | null | undefined
  className?: string
  as?: 'div' | 'span'
}

const CountryFlag: FC<CountryFlagProps> = ({
  countryId,
  className,
  as = 'div',
}) => {
  if (!countryId) return null

  const flagComponents = {
    fi: FinnishFlagSmall,
    at: AustrianFlagSmall,
    be: BelgianFlagSmall,
    nl: DutchFlagSmall,
    it: ItalianFlagSmall,
    sv: SwedishFlagSmall,
    de: GermanFlagSmall,
  } as const

  const FlagComponent = flagComponents[countryId]

  if (!FlagComponent) return null

  if (as === 'span') {
    return (
      <span className={className}>
        <FlagComponent />
      </span>
    )
  }

  return (
    <div
      className={`flex-direction-column ${className}`}
    >
      <FlagComponent />
    </div>
  )
}

export default CountryFlag
